import { createContext } from 'react'
import { NavigationState, initialState } from '@reducers/NavigationReducer'

type VoidFunction = () => void
interface NavigationContextProps extends NavigationState {
  setPrevHandler(handler: undefined | VoidFunction): void;
  setNextHandler(handler: undefined | VoidFunction): void;
  setResetHandler(handler: undefined | VoidFunction): void;
  setShareHandler(handler: undefined | VoidFunction): void;
}

export const initialNavigationContext: NavigationContextProps = {
  ...initialState,
  setPrevHandler: () => {},
  setNextHandler: () => {},
  setResetHandler: () => {},
  setShareHandler: () => {},
}

export const NavigationContext = createContext<NavigationContextProps>(initialNavigationContext)
